import ComponentWithSocket from '../../lib/component';
import { Component } from 'vue-property-decorator';
import moment from 'moment';
import * as Store from '../../store';

@Component
export default class PostBids extends ComponentWithSocket {
    bids: any[] = [];
    currencySymbol: string = '€';
    data: any = {
        currentPage: 1,
        perPage: 25,
        bidsCount: 0,
    };

    constructor() {
        super();

        this.wsListener.onGet('orders.paginated', (success: boolean, payload: any) => {
            Store.commitLoaderVisibility(this.$store, false);
            this.bids.splice(0, this.bids.length);
            if (success) {
                this.data.bidsCount = payload.bidsCount;
                for (const bid of payload.bids) {
                    this.bids.push(bid);
                }
            }
        });

        this.wsListener.onPost(
            'orders.accept',
            (success: boolean, data: any) => {
                if (!success) {
                    Store.commitLoaderVisibility(this.$store, false);
                    alert(data);
                } else {
                    this.reloadBids(this.data.currentPage);
                }
            },
        );

        this.wsListener.onPost(
            'orders.declined',
            (success: boolean, data: any) => {
                if (!success) {
                    Store.commitLoaderVisibility(this.$store, false);
                    alert(data);
                } else {
                    this.reloadBids(this.data.currentPage);
                }
            },
        );
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from);
        next();
    }

    mounted() {
        this.reloadBids(1);
    }

    reloadBids(page: any = this.data.currentPage) {
        Store.commitLoaderVisibility(this.$store, true);
        this.data.currentPage = page;

        this.wsListener.sendGet('orders.paginated', {
            perPage: this.data.perPage,
            currentPage: page,
        });
    }

    acceptOffer(id: string) {
        if (confirm('Esti sigur ca vrei sa accepti oferta?')) {
            Store.commitLoaderVisibility(this.$store, true);
            this.wsListener.sendPost('orders.accept', { id });
        }
    }

    declinedOffer(id: string) {
        if (confirm('Esti sigur ca vrei sa refuzi oferta?')) {
            Store.commitLoaderVisibility(this.$store, true);
            this.wsListener.sendPost('orders.declined', { id });
        }
    }

    strippedContent = (text: string) => {
        const regex = /(<([^>]+)>)/gi;
        return text.replace(regex, '');
    }

    formatDate(dateString: string): string {
        return moment(dateString).format('DD.MM.YYYY, HH:mm');
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/post-bids/index.ts